export default __webpack_public_path__ + "static/media/42.9a083ced.png";